module.exports = __webpack_public_path__ + "img/twin-panel-background.139efee5.jpg";